<template>
  <b-modal
    id="webhook-details-modal"
    ref="webhookDetailsModal"
    title="Webhook Details"
    hide-footer
    size="lg">
    <b-form-group>
      <label
        class="col-form-label pt-0">
        Webhook Secret Key
      </label>
      <CopyInput :value="webhookp.secret_key"/>
    </b-form-group>
  </b-modal>
</template>

<script>
import CopyInput from '../../../../common/CopyInput';


export default {
  name: 'WebhookDetailsModal',
  components: {
    CopyInput,
  },
  props: {
    webhookp: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    show() {
      this.$refs.webhookDetailsModal.show();
    },
    hide() {
      this.$refs.webhookDetailsModal.hide();
    },
  },
};
</script>
